import { useMutation, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useAppSelector } from 'src/services/redux/app/store';

const REACT_APP_API_URL = `${process.env.REACT_APP_API_URL}`;

export const useSalesOpportunitiesList = (params: any = {}, onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const { page, limit, sortBy, search, sales_staff, start_date, end_date, customer_id, customer_type, erp_customer_id } = params;

  // Belirli bir müşterinin kartı açıldığında o müşterinin tüm fırsatları gösterilir,
  // kayıt sahibi personele göre daraltılmaz.
  const hasCustomerFilter = !!(customer_id || erp_customer_id);

  const requestParams = {
    contact_info_id: user?.company_id,
    page,
    limit,
    sortBy,
    search,
    // Varsayılan olarak mevcut kullanıcının kayıtlarını göster
    sales_staff: sales_staff || (hasCustomerFilter ? undefined : user?.id),
    start_date,
    end_date,
    // Müşteri kartı bazlı listeleme: açıklama araması yerine kimlik ile filtrele
    customer_id,
    customer_type,
    erp_customer_id,
  };
  const requestUrl = REACT_APP_API_URL + '/sales-opportunities/list';
  const fetchData = async () => {
    const res = await axios.get<any>(`${requestUrl}`, { params: requestParams });
    return res?.data || {};
  };
  return useQuery(['sales-opportunities-list', params], fetchData, {
    refetchOnWindowFocus: false,
    onError,
    staleTime: Infinity,
    retry: false,
  });
};

export const useSalesOpportunityCreate = (onSuccess?: any, onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestUrl = REACT_APP_API_URL + '/sales-opportunities/create';
  return useMutation(
    (formPayload: any) => {
      return axios.post(`${requestUrl}`, { ...formPayload, contact_info_id: user?.company_id });
    },
    { onError, onSuccess },
  );
};

export const useSalesOpportunityUpdate = (onSuccess?: any, onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestUrl = REACT_APP_API_URL + '/sales-opportunities/update';
  return useMutation(
    (formPayload: any) => {
      return axios.post(`${requestUrl}`, { ...formPayload, contact_info_id: user?.company_id });
    },
    { onError, onSuccess },
  );
};

export const useSalesOpportunityDelete = (onSuccess?: any, onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestUrl = REACT_APP_API_URL + '/sales-opportunities/delete';
  return useMutation(
    (formPayload: any) => {
      return axios.post(`${requestUrl}`, { ...formPayload, contact_info_id: user?.company_id });
    },
    { onError, onSuccess },
  );
};

export const useSalesOpportunityDetail = (id: string | number, enabled: boolean = true, onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestUrl = REACT_APP_API_URL + '/sales-opportunities/detail';
  const fetchData = async () => {
    const res = await axios.post<any>(`${requestUrl}`, { id, contact_info_id: user?.company_id });
    return res?.data || {};
  };
  return useQuery(['sales-opportunity-detail', id], fetchData, {
    refetchOnWindowFocus: false,
    onError,
    staleTime: Infinity,
    retry: false,
    enabled: !!id && enabled,
  });
};

export const useSalesStaffList = (onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestParams = { id: user?.company_id, limit: 1000 };
  const requestUrl = REACT_APP_API_URL + '/company/users/saleslist';
  const fetchData = async () => {
    const res = await axios.get<any>(`${requestUrl}`, { params: requestParams });
    return res?.data || {};
  };
  return useQuery(['sales-staff-list'], fetchData, {
    refetchOnWindowFocus: false,
    onError,
    staleTime: Infinity,
    retry: false,
    enabled: !!user?.company_id,
  });
};
